<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button type="button" id="btnToevoegen" class="btn btn-primary btn-xs" @click.prevent="btnToevoegen">
          <font-awesome-icon icon="plus" />
          {{ translation(5023) }}
        </button>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(5021) }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p v-html="translation(5022)"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <XVtableV2
          :filterfunc="filterfunc"
          :tablesetting="personRolesTable.tablesetting"
          :tablecolumnsetting="personRolesTable.tablecolumnsetting"
          :tabledata="personRolesTable.tabledata"
          v-on:sortXVTable="XVTablesort"
          :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
          :detailVisibleLargeScreen="visibleLargeScreen"
          :tableSearchBox="tablesearchboxvisible"
        >
          <template slot="tblPersonWijzig" slot-scope="dr">
            <span :id="'wijzig_' + [dr.index]" @click="wijzigPersoon(dr)" :title="translation(14764)">
              <font-awesome-icon
                :icon="['far', 'calendar-edit']"
                class="initial pointer"
                v-bind:class="{ hideIcon: dr.row.tableRowState.editModus }"
              />
              <font-awesome-icon
                icon="chevron-up"
                class="initial pointer"
                v-bind:class="{ hideIcon: !dr.row.tableRowState.editModus }"
              />
            </span>
          </template>
          <template slot="tblPersonVerwijder" slot-scope="dr">
            <span :id="'verwijder_' + [dr.index]" @click="openConfirm(dr)" :title="translation(150)">
              <font-awesome-icon :icon="['fa', 'trash']" class="initial pointer" />
            </span>
          </template>
          <template slot="detailrow" slot-scope="tablerow">
            <div :class="'row ' + margin20MD" v-show="XSvisible">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(4993) }}</label>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.tblPersonEmail }}</div>
            </div>
            <div class="row" v-show="XSvisible">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(5025) }}</label>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback">
                {{ tablerow.row.tblExternalOrganizationName }}
                {{ tablerow.index }}
              </div>
            </div>
            <div class="row" v-show="XSvisible">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(5027) }}</label>
              </div>
              <div class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback">{{ tablerow.row.rollen }}</div>
            </div>
            <div class="row margin20" v-show="tablerow.row.tableRowState.editModus && XSinvisible">
              <div class="col-md-12">
                <p v-html="translation(5029)"></p>
              </div>
            </div>
            <div class="row" v-show="tablerow.row.tableRowState.editModus">
              <div class="col-md-4 col-sm-12 col-xs-12">
                <label>{{ translation(5026) }}</label>
              </div>
              <div
                class="col-md-8 col-sm-12 col-xs-12 form-group has-feedback"
                v-bind:class="{ 'form-group--error': errors.has('tbxDatum' + tablerow.index) }"
              >
                <XVdate
                  :id="'tbxDatum_' + tablerow.index"
                  v-model="tablerow.row.tableRowState.datumSelected"
                  :name="'tbxDatum' + tablerow.index"
                  data-vv-as="Datum"
                  v-validate="{ XVDateDefault: true }"
                ></XVdate>
                <span class="form-group__message">{{ errors.first('tbxDatum' + tablerow.index) }}</span>
              </div>
            </div>
            <div class="row XVtablebtnrow">
              <div class="col-md-12">
                <div class="btn-group XVtablerowbtngroup">
                  <button
                    :id="'btnSave' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="btnSave(tablerow)"
                    v-show="tablerow.row.tableRowState.editModus"
                  >
                    <font-awesome-icon :icon="['far', 'save']" />
                    {{ translation(14702) }}
                  </button>
                  <button
                    :id="'btnCancel' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="btnCancel(tablerow.index)"
                    v-show="tablerow.row.tableRowState.editModus"
                  >
                    <font-awesome-icon icon="times" />
                    {{ translation(17) }}
                  </button>
                </div>
                <div class="btn-group XVtablerowbtngroup">
                  <button
                    :id="'btnWijzig' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="btnWijzig(tablerow.index)"
                    v-show="!tablerow.row.tableRowState.editModus && (wXS === true || wSM === true || wMD === true)"
                  >
                    <font-awesome-icon :icon="['far', 'calendar-edit']" />
                    {{ translation(14589) }}
                  </button>
                  <button
                    :id="'btnVerwijder' + tablerow.index"
                    type="button"
                    class="btn btn-primary XVtablerowbutton"
                    @click.prevent="openConfirm(tablerow)"
                    v-show="!tablerow.row.tableRowState.editModus && (wXS === true || wSM === true || wMD === true)"
                  >
                    <font-awesome-icon :icon="['fa', 'trash']" />
                    {{ translation(150) }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </XVtableV2>
        <modal v-model="showConfirm" title="Modal 1" ref="modal" id="modal-demo" :header="false">
          <p v-html="translation(5040)"></p>
          <div slot="footer" class="modalconfirmbuttons">
            <button
              id="btnDeleteModal"
              type="button"
              class="btn btn-primary modalconfirmbutton"
              @click.prevent="deleteConfirm()"
            >
              {{ translation(23) }}
            </button>
            <button
              id="btnCloseModal"
              type="button"
              class="btn btn-primary modalconfirmbutton"
              @click.prevent="closeConfirm"
            >
              {{ translation(17) }}
            </button>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin, util } from 'pevueglobal'

export default {
  mixins: [FAMixin],
  data: function () {
    return {
      Iautdate: null,
      datumSelected: [],
      showConfirm: false,
      selectedUser: 0,
    }
  },
  computed: {
    ...mapGetters('Spe671PrExtOrgMyAdmins', ['personRolesTable', 'XVtableGetRowStateProperty', 'XVtableGetValue']),
    XSinvisible: function () {
      if (this.wLG || this.wXL) {
        return true
      } else {
        return false
      }
    },
    XSvisible: function () {
      if (this.wXS || this.wSM || this.wMD) {
        return true
      } else {
        return false
      }
    },
    margin20MD: function () {
      if (this.wXS || this.wSM || this.wMD) {
        return 'margin20'
      } else {
        return ''
      }
    },
    visibleLargeScreen: function () {
      if ((this.wXL || this.wLG) && this.wijzigModus === true) {
        return true
      } else {
        return false
      }
    },
    tablesearchboxvisible: function () {
      // searchbox pas zichtbaar als er meer dan 10 items in tabel staan
      if (this.personRolesTable.tabledata.length >= 10) {
        return true
      } else {
        return false
      }
    },
  },
  async mounted() {
    await this.getTexten()
    await this.getPersonRoles()
    this.stopLoading()
  },
  methods: {
    ...mapActions('Spe671PrExtOrgMyAdmins', ['getTexten', 'getPersonRoles', 'updateDate', 'deleteMentor']),

    ...mapMutations('Spe671PrExtOrgMyAdmins', [
      'XVTablesort',
      'XVtablecolumnsettingchanged',
      'XVtableSetRowStateProperty',
    ]),
    filterfunc: function (tabledata) {
      return tabledata
      // Kijken if er data gevuld is in bepaalde columns. Als er geen data is dan kan de column op invisible gezet worden.
      // 1e check of tblPersonPEActivityPEPoints gevuld is
    },
    btnToevoegen: function () {
      this.$router.push({ path: '/peapp/prof/Spe673PRExtOrgAdmindetail/' })
    },
    wijzigPersoon: function (tablerow) {
      if (tablerow.row.tableRowState.editModus === false) {
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: true,
        })
        this.XVtableSetRowStateProperty({ index: tablerow.index, stateProperty: 'editModus', statePropertyValue: true })
        let datum = this.XVtableGetValue({
          index: tablerow.index,
          columnname: 'tblExternalOrganizationAdministratorProfDateUpTo',
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'datumSelected',
          statePropertyValue: datum,
        })
      } else {
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: false,
        })
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'editModus',
          statePropertyValue: false,
        })
      }
    },
    btnCancel: function (index) {
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'datumSelected', statePropertyValue: null })
      if (this.wXS || this.wSM) {
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: true })
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: false })
      } else {
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: false })
        this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: false })
      }
    },
    btnWijzig: function (index) {
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'rowVisible', statePropertyValue: true })
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'editModus', statePropertyValue: true })
      let datum = this.XVtableGetValue({ index: index, columnname: 'tblExternalOrganizationAdministratorProfDateUpTo' })
      this.XVtableSetRowStateProperty({ index: index, stateProperty: 'datumSelected', statePropertyValue: datum })
    },
    clickcheck: function (tablerow) {
      let check = tablerow.row.tableRowState.check === undefined ? true : !tablerow.row.tableRowState.check
      this.XVtableSetRowStateProperty({ index: tablerow.index, stateProperty: 'check', statePropertyValue: check })
    },
    btnSave: function (tablerow) {
      if (!this.errors.has('tbxDatum' + tablerow.index)) {
        let date = util.DateForDatabase(tablerow.row.tableRowState.datumSelected)

        let updateString = [{ intvalue: tablerow.row.tblExternalOrganizationAdministratorID, datevalue: date }]
        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'editModus',
          statePropertyValue: false,
        })
        this.updateDate({ DateUpToAndAdminID: updateString })

        this.XVtableSetRowStateProperty({
          index: tablerow.index,
          stateProperty: 'rowVisible',
          statePropertyValue: false,
        })
      }
    },
    openConfirm: function (tablerow) {
      this.showConfirm = true
      this.selectedUser = tablerow.row.tblExternalOrganizationAdministratorID
    },
    closeConfirm: function () {
      this.showConfirm = false
    },
    deleteConfirm: function () {
      this.deleteMentor(this.selectedUser)
      this.showConfirm = false
    },
  },
}
</script>
